import { Checkbox } from '@mui/material';
import PropTypes from 'prop-types';

const CrpCheckbox = (props) => {
  const { onChange, onClick, checked, style } = props;
  return (
    <Checkbox
      value="secondary"
      color="primary"
      checked={checked}
      onChange={onChange}
      style={style}
      onClick={onClick}
    />
  );
};

CrpCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default CrpCheckbox;
